/*!
 * MakNorte — Wishlist + Recently Viewed
 * Usa localStorage (sem backend) — simples e rápido
 */
(function(){
  const WISHLIST_KEY = 'mak_wishlist';
  const VIEWED_KEY = 'mak_viewed';
  const MAX_VIEWED = 12;

  function load(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); }
    catch(e) { return []; }
  }
  function save(key, arr) {
    try { localStorage.setItem(key, JSON.stringify(arr)); } catch(e){}
  }

  // ═══ 1. WISHLIST — adicionar heart button em cada card ═══
  function addHeartButtons() {
    const wishlist = load(WISHLIST_KEY);
    document.querySelectorAll('product-card:not([data-mak-heart])').forEach(card => {
      card.dataset.makHeart = '1';
      const productId = card.dataset.productId;
      if (!productId) return;

      const gallery = card.querySelector('.card-gallery, .media-fit');
      if (!gallery) return;

      const btn = document.createElement('button');
      btn.className = 'mak-wishlist-btn';
      btn.setAttribute('aria-label', 'Favoritar');
      btn.dataset.productId = productId;
      if (wishlist.includes(productId)) btn.classList.add('is-active');

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const list = load(WISHLIST_KEY);
        const idx = list.indexOf(productId);
        if (idx > -1) {
          list.splice(idx, 1);
          btn.classList.remove('is-active');
        } else {
          list.push(productId);
          btn.classList.add('is-active');
          // Pequena animação
          btn.style.transform = 'scale(1.3)';
          setTimeout(() => btn.style.transform = '', 200);
        }
        save(WISHLIST_KEY, list);
        window.dispatchEvent(new CustomEvent('mak-wishlist-updated'));
      });

      gallery.appendChild(btn);
    });
  }

  // ═══ 2. TRACK RECENTLY VIEWED ═══
  function trackViewed() {
    if (window.location.pathname.indexOf('/products/') !== 0) return;
    // Pega slug do produto
    const slug = window.location.pathname.replace('/products/', '').split('?')[0].split('/')[0];
    if (!slug) return;

    let viewed = load(VIEWED_KEY);
    // Remove se já tinha (pra colocar no topo)
    viewed = viewed.filter(s => s !== slug);
    viewed.unshift(slug);
    if (viewed.length > MAX_VIEWED) viewed = viewed.slice(0, MAX_VIEWED);
    save(VIEWED_KEY, viewed);
  }

  // ═══ 3. RENDER RECENTLY VIEWED ═══
  async function renderRecentlyViewed() {
    const container = document.querySelector('[data-mak-recently-viewed]');
    if (!container) return;

    const viewed = load(VIEWED_KEY);
    // Remove o produto atual se estiver numa PDP
    const currentSlug = window.location.pathname.startsWith('/products/')
      ? window.location.pathname.replace('/products/', '').split('?')[0]
      : null;
    const list = viewed.filter(s => s !== currentSlug).slice(0, 8);
    if (list.length === 0) return;

    const frag = document.createDocumentFragment();
    const grid = document.createElement('div');
    grid.className = 'mak-recently-viewed__grid';

    for (const slug of list) {
      try {
        const res = await fetch(`/products/${slug}.js`);
        if (!res.ok) continue;
        const p = await res.json();
        const card = document.createElement('a');
        card.href = `/products/${p.handle}`;
        card.className = 'mak-recently-viewed__card';
        card.innerHTML = `
          <img src="${p.featured_image || p.images[0]}" alt="${p.title}" loading="lazy">
          <div class="mak-recently-viewed__card-info">
            <div class="mak-recently-viewed__card-title">${p.title}</div>
            <div class="mak-recently-viewed__card-price">R$ ${(p.price/100).toFixed(2).replace('.',',')}</div>
          </div>
        `;
        grid.appendChild(card);
      } catch(e) {}
    }

    if (grid.children.length > 0) {
      const title = document.createElement('h3');
      title.className = 'mak-recently-viewed__title';
      title.textContent = '👁️ Produtos Vistos Recentemente';
      frag.appendChild(title);
      frag.appendChild(grid);
      container.appendChild(frag);
    }
  }

  // ═══ 4. RENDER WISHLIST (pra página /pages/wishlist) ═══
  async function renderWishlist() {
    const container = document.querySelector('[data-mak-wishlist]');
    if (!container) return;

    const wishlist = load(WISHLIST_KEY);
    if (wishlist.length === 0) {
      container.innerHTML = '<p style="padding:2rem 1rem;color:#6B7280;text-align:center;">Sua lista de desejos está vazia. Navegue pelo catálogo e clique no ❤️ para favoritar!</p>';
      return;
    }

    const frag = document.createDocumentFragment();
    const grid = document.createElement('div');
    grid.className = 'mak-wishlist-section__grid';

    for (const pid of wishlist) {
      try {
        const res = await fetch(`/products.json?ids=${pid}`);
        // Fallback: direct product fetch by id doesn't work, need to map
      } catch(e) {}
    }

    // Método alternativo: loop pelo DOM pra achar o handle via API /products.json
    // Mas sem handle armazenado, melhor trocar pra guardar handle em vez de ID
  }

  // ═══ 5. INIT ═══
  function init() {
    trackViewed();
    addHeartButtons();
    renderRecentlyViewed();
    renderWishlist();
    // Re-aplica após navegação Ajax
    const observer = new MutationObserver(() => addHeartButtons());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
